import { Field, Form, FormikProps } from 'formik';
import { FormikTextInput } from '@forms/Components/TextInput';
import { MultiContainerUpdateFormik } from './types';

import styles from './MultiContainerUpdate.module.css';

type MultiContainerUpdateFormProps = FormikProps<MultiContainerUpdateFormik> & {
	id: string;
};

/**
 * Form component for the Multi Container Update Modal
 */
export default function MultiContainerUpdateForm(props: MultiContainerUpdateFormProps) {
	return (
		<Form
			id={props.id}
			className={styles.form}
		>
			<Field
				name='customerRef'
				label='Customer Ref.'
				component={FormikTextInput}
			/>
		</Form>
	);
}
